var map = {
  "./zh-Hans/grafana-enterprise.json": [
    "18249",
    [
      14226
    ]
  ],
  "./de-DE/grafana-enterprise.json": [
    "23749",
    [
      76678
    ]
  ],
  "./es-ES/grafana-enterprise.json": [
    "16119",
    [
      36028
    ]
  ],
  "./cs-CZ/grafana-enterprise.json": [
    "59370",
    [
      14135
    ]
  ],
  "./id-ID/grafana-enterprise.json": [
    "10045",
    [
      79694
    ]
  ],
  "./ja-JP/grafana-enterprise.json": [
    "68268",
    [
      13405
    ]
  ],
  "./ko-KR/grafana-enterprise.json": [
    "73638",
    [
      81163
    ]
  ],
  "./en-US/grafana-enterprise.json": [
    "29740",
    [
      67709
    ]
  ],
  "./nl-NL/grafana-enterprise.json": [
    "8707",
    [
      38048
    ]
  ],
  "./pl-PL/grafana-enterprise.json": [
    "30135",
    [
      13647
    ]
  ],
  "./ru-RU/grafana-enterprise.json": [
    "4265",
    [
      2578
    ]
  ],
  "./sv-SE/grafana-enterprise.json": [
    "5442",
    [
      7775
    ]
  ],
  "./hu-HU/grafana-enterprise.json": [
    "67837",
    [
      80238
    ]
  ],
  "./tr-TR/grafana-enterprise.json": [
    "7487",
    [
      94900
    ]
  ],
  "./pt-PT/grafana-enterprise.json": [
    "52471",
    [
      54908
    ]
  ],
  "./zh-Hant/grafana-enterprise.json": [
    "77938",
    [
      5455
    ]
  ],
  "./fr-FR/grafana-enterprise.json": [
    "87179",
    [
      96632
    ]
  ],
  "./pt-BR/grafana-enterprise.json": [
    "50972",
    [
      22948
    ]
  ],
  "./it-IT/grafana-enterprise.json": [
    "83709",
    [
      15790
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 74083;
module.exports = __rspack_async_context;
